import { render, staticRenderFns } from "./newsletterCS.vue?vue&type=template&id=0b2570ba"
import script from "./newsletterCS.vue?vue&type=script&lang=js"
export * from "./newsletterCS.vue?vue&type=script&lang=js"
import style0 from "./newsletterCS.vue?vue&type=style&index=0&id=0b2570ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports